import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {support_to_url} from "./support";
import {Observable, of} from "rxjs";
import {mergeMap} from "rxjs/operators";

@Component({
  selector: 'edsng-support',
  template: '<p>Redirect to request <a href="{{supportUrl}}">support page</a></p>',
  styleUrls: ['./support.component.css']
})
export class SupportComponent implements OnInit {
  supportUrl =  '/';

  constructor(private route: ActivatedRoute) {
  }

  logRequest(x: any): Observable<string> {
    const lang = x['lang'];
    const req = x['request'];
    const event = 'support_request';
    const targetUrl = support_to_url(req, lang);
    this.supportUrl = targetUrl;
    return of(targetUrl);
  }

  ngOnInit() {
    this.route.params.pipe(
      mergeMap(x => this.logRequest(x))
    ).subscribe(url => {
      window.location.replace(url);
    });
  }

}
